export const urlSegmentId = 'segment_id'
